module.exports = __webpack_public_path__ + "media/8.76a33692.mp3";